import React from "react";
import "./Photos.css";
import Gallery1 from "../../img/Gallery_1.png"
import Gallery2 from "../../img/Gallery_2.png"
import Gallery3 from "../../img/Gallery_3.png"
import Gallery4 from "../../img/Gallery_4.png"

const Photos = () => {
  const state = {
    Speakers_item: [
        {
          teamAlt: "Gallery_1",
          img: Gallery1
        },
        {
          teamAlt: "Gallery_2",
          img: Gallery2
        },
        {
          teamAlt: "Gallery_3",
          img: Gallery3
        },
        {
          teamAlt: "Gallery_4",
          img: Gallery4
        }
    ],
  };

  const renderSpeakers_item = (item, i) => {
      return (
          <img className="team_photo" src={item.img} alt={item.teamAlt} />
      );
  };

  return (
    <div className="team container--full">
      {state.Speakers_item.map((item, i) => renderSpeakers_item(item, i))}
    </div>
  );
};

export default Photos;
